import { useSelector } from "react-redux";
import { LOCATION_TYPE } from "../../Location/Data";
import { PARTNER_ROLE } from "../Data";

const useLocationOnAdd = (watch) => {
  const { userDetails } = useSelector((state) => state.loggedInUser);
  const { allLocations } = useSelector((state) => state.locations);

  const selectedRole = watch("roleId") ?? 1;

  // return only delivery points if selected role is an offtaker
  if (+selectedRole === PARTNER_ROLE.OFFTAKER) {
    return allLocations
      .filter(
        (item) =>
          item.type === LOCATION_TYPE.DELIVERY &&
          userDetails.hubs.includes(parseInt(item.hubId, 10)),
      )
      .map((location) => ({
        id: location.id,
        value: location.name,
      }));
  }

  // return collection and aggregation points if selected role is a farmer
  return allLocations
    .filter(
      (item) =>
        [LOCATION_TYPE.COLLECTION, LOCATION_TYPE.AGGREGATION].includes(
          item.type,
        ) && userDetails.hubs.includes(parseInt(item.hubId, 10)),
    )
    .map((location) => ({
      id: location.id,
      value: location.name,
    }));
};

export default useLocationOnAdd;
